import { connect } from 'react-redux'
import { IGlobalState } from '../../../../Root/store/appReducer'
import {
  deleteUser,
  getCompanyUsers,
  setCompanyUsersLoading,
  setUserDivision,
  toggleUserStatus,
} from '../../../UserManagement/store/UserManagementActions'
import { setUserCategoryDivision } from '../../store/TeamManagementActions'
import { getCompanyUsersList, getCompanyUsersLoading } from '../../../UserManagement/store/UserManagementSelectors'
import { companyDivisionsSelector, managedCompaniesSelector } from '../../../Settings/store/SettingsSelectors'
import { getCompanyDivisions } from '../../../Settings/store/SettingsActions'
import TeamMembersTable, { ITeamMembersTablePropsDispatchProps } from './TeamMembersTable'
import { CompanyId, DivisionId, DivisionCategoryId, DivisionRow, DivisionDto } from '../../../../services/api.types'
import { getCreatedDivisionId, getDeletedDivisionIds } from '../../store/TeamManagementSelectors'

interface ITeamMembersTableOwnProps {
  companyId: CompanyId
  divisionId: DivisionId
  categoryId?: DivisionCategoryId
  //companyGroups?: { [companyId: string]: { [categoryId: string]: DivisionRow[] } }
  divisions: DivisionDto[]
}

const mapStateToProps = (state: IGlobalState, ownProps: ITeamMembersTableOwnProps) => ({
  companyId: ownProps.companyId,
  divisionId: ownProps.divisionId,
  categoryId: ownProps.categoryId,
  //companyGroups: ownProps.companyGroups,
  divisions: ownProps.divisions,
  companyUsers: getCompanyUsersList(state),
  //divisions: companyDivisionsSelector(state),
  usersLoading: getCompanyUsersLoading(state),
  managedCompanies: managedCompaniesSelector(state),
  createdDivisionId: getCreatedDivisionId(state),
  deletedDivisionIds: getDeletedDivisionIds(state),
})

const mapDispatchToProps: ITeamMembersTablePropsDispatchProps = {
  deleteUser,
  getCompanyUsers,
  getCompanyDivisions,
  toggleUserStatus,
  setUserDivision,
  setUserCategoryDivision,
  setCompanyUsersLoading,
}

export default connect(mapStateToProps, mapDispatchToProps)(TeamMembersTable)
